import ButtonGroup from './button-group.vue';

export default ButtonGroup;
